var g_dev = false;

/* window vars */
var g_windowHeight = $(window).height();
var g_windowWidth = $(window).width();
$(window).resize(function() {
    g_windowHeight = $(window).height();
    g_windowWidth = $(window).width();
});

/* scroll vars */
var g_scroll = $(window).scrollTop();
$(window).scroll(function() {
    g_scroll = $(window).scrollTop();
});

$(document).ready(function(){

    /* fancybox */
    $(".fancybox").fancybox();
    $(".gallery li a").fancybox();

    $(".fancybox[data-fancybox-type=iframe]").fancybox({
        closeEffect: 'none',
        scrolling: 'hidden',
        openEffect: 'none',
        autoSize: 'false',
        height: '100%',
        width: '100%',
        padding: 0,
        margin: 0,
        helpers: {
            overlay: null,
            title : null
        },
        beforeLoad: function () {
            $('html').addClass("fancybox-locked");
        },
        afterClose: function () {
            $('html').removeClass("fancybox-locked");
        }
    });

    /* Mobile menu */
    mobileMenu();
    $(window).resize(mobileMenu);

    /* Search width */
    searchWidth();
    $(window).resize(searchWidth);

    /* Sidebar width */
    sidebarWidth();
    $(window).resize(sidebarWidth);

    /* EqualHeight */
    $(window).resize(equalHeight);

    /* Dismiss alert */
    $(".alert .icon-cross").on('click', function(e) {
        e.preventDefault();
        $(this).parent().remove();
    });

    /* List-toggle */
    $(".list-toggle li .label").on('click', function(e) {
        $(this).parent().siblings().removeClass("active");
        $(this).parent().toggleClass("active");
    });
    $(".list-toggle li:first-child .label").trigger('click');

    /* info-tabs */
    $(".info-tabs .tab").on('click', function() {
        /* $(this).siblings().removeClass("active"); */
        $(this).toggleClass("active");
    });

    /* Clickable */
    $('.clickable').mousedown(function(e) {
        switch (e.which) {
        case 1:
            window.location=$(this).find("a").attr("href");
            return false;
        case 2:
            window.open($(this).find("a").attr("href"));
            break;
        }
    });

    /* Social media share buttons */
    $('.share').on('click', function(e){
        e.preventDefault();
        var target = $(this).attr('href');
        window.open(target, 'popup', 'width = 500, height = 300');
    });

    /* Twitterfeed */
    if ($('#twitterfeed').length > 0) {
        var config1 = {
            "id": '388314281537568768',
            "domId": 'twitterfeed',
            "showUser": false,
            "maxTweets": 1,
            "enableLinks": true,
            "showInteraction": false,
            "lang": 'nl'
        };
        twitterFetcher.fetch(config1);
    }

    /* Responsive table */
    var $table = $('.responsive-table table');
    var $fixedColumn = $table.clone().insertBefore($table).removeClass('basis-table').addClass('fixed-column');
    $fixedColumn.find('th:not(:first-child),td:not(:first-child)').remove();
    setTableHeight();

    /* Sliders */
    $('.slider').slick({
        autoplaySpeed: 5000,
        pauseOnHover: false,
        slidesToScroll: 1,
        draggable: true,
        slidesToShow: 1,
        autoplay: false,
        infinite: true,
        arrows: false,
        dots: false,
        speed: 500
    });

    $('.project-slider').slick({
        autoplaySpeed: 5000,
        pauseOnHover: false,
        slidesToScroll: 1,
        draggable: true,
        slidesToShow: 3,
        autoplay: false,
        infinite: true,
        arrows: true,
        dots: false,
        speed: 500,
        responsive: [
            {
                breakpoint: 959,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $('.product-slider').slick({
        autoplaySpeed: 5000,
        pauseOnHover: false,
        slidesToScroll: 1,
        draggable: true,
        slidesToShow: 4,
        autoplay: false,
        infinite: true,
        arrows: true,
        dots: false,
        speed: 500,
        responsive: [
            {
                breakpoint: 959,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    /* product page */
    $('.slider-gallery').slick({
        autoplaySpeed: 5000,
        pauseOnHover: false,
        slidesToScroll: 1,
        draggable: true,
        slidesToShow: 3,
        autoplay: false,
        infinite: true,
        arrows: true,
        dots: false,
        speed: 500,
        responsive: [
            {
                breakpoint: 479,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });

    $('.slider-offer').slick({
        verticalSwiping: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        slidesToScroll: 1,
        draggable: true,
        slidesToShow: 1,
        autoplay: true,
        vertical: true,
        infinite: true,
        arrows: false,
        dots: false,
        speed: 500
    });

    /* Smooth scroll */
    $('a.scroll_link').click(function(){
        if ($('[name="' + $.attr(this, 'href').substr(1) + '"]').length>0) {
            $('html, body').animate({
                scrollTop: $('[name="' + $.attr(this, 'href').substr(1) + '"]').offset().top - 64
            }, 500);
        }
        return false;
    });

    /* Hoofdmenu */
    $("body").on('click', '.btn-mobile-menu', function(e){
        e.preventDefault();
        e.stopPropagation();
        $('body').addClass('open_menu');
    });

    /* Toggle overlay */
    $('body').on('click', '#mobile_overlay', function(e){
        e.preventDefault();
        $('body.open_menu').removeClass('open_menu');
    });

    /* Viewport */
    $('.change-viewport').click(function(){
        $('#viewport').remove();
    });

    /* Datepicker */
    $.datepicker.setDefaults($.extend(
        {'dateFormat':'dd-mm-yy'},
        $.datepicker.regional['nl']
    ));

    /* Temp restrict days */
    const restrictedDates = [
        '2022-02-26',
        '2022-02-28',
        '2022-03-01',
        '2023-07-29',
        '2023-07-30',
        '2023-07-31',
        '2023-08-01',
        '2023-08-02',
        '2023-08-03',
        '2023-08-04',
        '2023-08-05',
        '2023-08-06',
        '2023-08-07',
        '2023-08-08',
        '2023-08-09',
        '2023-08-10',
        '2023-08-11',
        '2023-08-12',
        '2023-08-13',
        '2023-08-14',
        '2023-08-15',
        '2023-08-16',
        '2023-08-17',
        '2023-08-18',
        '2023-08-19',
        '2023-08-20',
    ];

    $(".datepicker").datepicker({
        dayNamesMin: [ "Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za" ],
        monthNames: [ "januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december" ],
        nextText: '»',
        prevText: '«',
        firstDay: 1,
        beforeShowDay(day) {
            const formatDay = jQuery.datepicker.formatDate('yy-mm-dd', day);
            return [restrictedDates.indexOf(formatDay) === -1];
        },
    });

});


/* Fixed menu */
$(document).ready(fixedMenu);
$(window).resize(fixedMenu);
$(window).scroll(fixedMenu);
function fixedMenu() {
    if (g_scroll > 36) {
        $('#menu').addClass('fixed');
    } else {
        $('#menu').removeClass('fixed');
    }
}

/* searchwidth */
function searchWidth(){
    var menuItems = $("#menu_header ul.topmenu > li:nth-last-child(1)").width()+$("#menu_header ul.topmenu > li:nth-last-child(2)").width()+$("#menu_header ul.topmenu > li:nth-last-child(3)").width();
    $(".header-right").width(menuItems-$(".header-socialmedia").width()+3);
}


/* Sidebar width */
function sidebarWidth(){
    $(".fixed-sidebar").width($(".sidebar").width());
}


/* Equalheight on window load */
$(window).load(function(){
    equalHeight();
});


/* Scrollto */
function goToByScroll(id){
    $('html,body').animate({scrollTop: $("#"+id).offset().top},'slow');
}


/* MobileMenu */
/* Adds a Mobile menu */
function mobileMenu() {
    /* Hoofdmenu
    if($('body').hasClass('mobile_menu')) {
        if ($("#menu_header-left ul").css("display") == "block" ) {
            $('body').removeClass('mobile_menu');
        }
    } else {
        if ($("#menu_header-left ul").css("display") == "none" ) {
            $('body').addClass('mobile_menu');
        }
    } */
}



/* ResponsiveTable */
/* Add a fixed column on a responsive-table */
function setTableHeight() {
    $('div.responsive-table').each(function(){
        var div = $(this);
        $('table.basis-table tbody tr', div).each(function(i,el) {
            var hgt = $(this).outerHeight();
            $('table.fixed-column tr', div).eq(i).height(hgt);
            $('table.basis-table tbody tr', div).eq(i).height(hgt);
        });
        $('table tbody tr th', div).each(function(i,el) {
            var hgt = $(this).outerWidth();
            $('table.fixed-column', div).eq(i).width(hgt);
        });
    });
};
